import { Injectable } from '@angular/core';

@Injectable()
export class DetectDevicesService {
    constructor() {}
    isMobilePhone() {
        return window.matchMedia('(max-width: 768px)').matches;
    }
    isMobileSmall() {
        return window.matchMedia('(max-width: 450px)').matches;
    }
}
